import {Component, OnInit,NgZone} from '@angular/core';
import {BrandingService} from "../services/branding/branding.service";
import {AuthApiService} from "../services/api/authentication/auth-api-service";
import {AuthenticationService} from "../services/authentication/authentication.service";
import {ActivatedRoute, Router} from "@angular/router";
import { SdeskHelper } from '../shared/helper/SdeskHelper';
declare var turnstile: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public branding;
  public loginMethod;

  // User/Password form
  public emailAddress: string;
  public password: string;
  public username: string;

  public screen: string = 'loginScreen'; // loginScreen / passwordResetScreen / passwordResetSuccessful
  public showPasswordResetSuccessful: boolean = false;
  public showPasswordResetFailed: boolean = false;

  public returnPath: string;
  public showLoginFailedMessage = false;
  public showLoginSessionFailedMessage =false;
  HCAPTCHA_SITE_KEY;
  captchaToken: string;
  response: any;
  verifycaptcha = false;
  getverifycaptcha;
  isCaptchaAvailable;

  constructor(
    private brandingService: BrandingService,
    private authApi: AuthApiService,
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private ngZone: NgZone
  ) {
    brandingService.brandingSubscription.subscribe(data => this.branding = data);
    this.emailAddress = localStorage.getItem('login_email');
    this.loginMethod = localStorage.getItem('login_method');
  }

  ngOnInit(): void {
    // user can see the captcha only it's available for the instance
    this.checkCaptchaAvailability().then(status => {
      this.isCaptchaAvailable=status
      if(status==true){
          this.getCaptcha();
          (window as any).onTurnstileSuccess = async (token: string) => {
            try {
              this.response = await this.authApi.verifyCaptchaToken(token);
              this.ngZone.run(() => {
                this.verifycaptcha = true;
              });
              console.log(this.verifycaptcha)
              console.log('CAPTCHA verified (Promise):', this.response);
            } catch (error) {
              console.error('CAPTCHA verification failed (Promise):', error);
              this.ngZone.run(() => {
                this.verifycaptcha = false;
              });
              this.resetCaptcha(); //reset
            }
          };
      }
    });
   
    
    this.route.queryParams.subscribe(params => {
      this.returnPath = params['returnPath'];
      this.username = params['username'];
    });
  }

  getLoginMethod(){
    this.authApi.getLoginMethod(this.emailAddress).then(
      response => {
        this.setLoginMethod(response?.LoginMethod);
      }
    ).catch(error => {
      console.log("Failed to get login method.")
    })
  }

  async checkCaptchaAvailability(): Promise<boolean> {
    try {
      const response = await this.authApi.IsCaptchaAvailable();
      return response; //return captcha availability
    } catch (error) {
      console.error('Error checking captcha availability:', error);
      return false; 
    }
  }

  resetPassword(){
      // clear previous status
      this.showLoginFailedMessage = false;
      this.showPasswordResetSuccessful = false;
      this.showPasswordResetFailed = false;
    this.authApi.resetPassword(this.emailAddress).then(response => {
        if (SdeskHelper.isNotNullOrEmpty(response)) {
          this.showPasswordResetSuccessful = true
        } else {
          this.showPasswordResetFailed = true;
        }
      }
    )
  }

  setLoginMethod(method){
    localStorage.setItem('login_method', method);
    this.loginMethod = localStorage.getItem('login_method');

    localStorage.setItem('login_email', this.emailAddress);
  }

  clearLoginMethod(){
    localStorage.removeItem('login_method');
    localStorage.removeItem('login_email');

    this.loginMethod = null;
    this.emailAddress = null;
  }

  async getCaptcha() {
    try {
      const res = await this.authApi.getSiteKey();
      this.HCAPTCHA_SITE_KEY = res;
  
      // Wait a tick to let Angular update the DOM
      setTimeout(() => {
        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
      }, 0); // Small delay ensures the div exists in DOM
  
    } catch (error) {
      console.error('Failed to load CAPTCHA sitekey:', error);
    }
  }
  

  login(){
    // Clear login failed message
    this.showLoginFailedMessage = false;

      if(this.loginMethod == 'SSO'){
        // Redirect to SSO Authenticate backend handler
        const ssoUrl = `/ssoauthenticate?emailaddress=${this.emailAddress}&relayState=${window.location.href}`;
        window.location.href = this.username ? `${ssoUrl}&username=${this.username}`:ssoUrl;

      } else {
        //only get the captcha verification when the captcha is available for the instance
        if(this.isCaptchaAvailable){
          this.getverifycaptcha=this.response.success;
        }else{
          this.getverifycaptcha=null;
        }
        // Call Login API
        this.authApi.login(this.emailAddress, this.password,this.getverifycaptcha,this.isCaptchaAvailable).then(response => {
          const authToken = response?.AuthToken;
          const userName = response?.UserName

          if(authToken) {
            this.authService.setAuthToken(authToken);
            // this.authService.setUserName(userName);
            localStorage.setItem('userName', userName);
            this.authService.setUserName(userName);

            if(this.returnPath){
              this.router.navigate([this.returnPath]).catch(error => {
                console.log("route does not exist:" + error);
                this.router.navigate(['/']);
              });
            } else {
              this.router.navigate(['/']);
            }

          } else {
            this.showLoginFailedMessage = true;
          }

        }).catch(error => {
          //reset the captcha in the login incorrects
          // reset the captcha when it available for the instance
          if(this.isCaptchaAvailable){
            this.resetCaptcha(); //reset
          }
          
        // Extract the error message properly
          const errorMessage = error?.response?.data?.message || error?.message || error.toString();

          if (errorMessage.includes('Maximum session limit reached. Please log out from an existing session to continue.')) {
            this.showLoginSessionFailedMessage = true;
          } else {
            this.showLoginFailedMessage = true;
          }
        })
      }
  }

  resetCaptcha(): void {
    // Remove old widget if it exists
    const captchaContainer = document.getElementById('captcha-container');
    if (captchaContainer) {
      captchaContainer.innerHTML = '';
    }
  
    // Re-render the CAPTCHA and store the new widget ID without changing 
    const newWidgetId = turnstile.render('#captcha-container', {
      sitekey: this.HCAPTCHA_SITE_KEY,
      callback: (token: string) => {
        (window as any).onTurnstileSuccess(token);
      }
    });
  }
  
}
